export const makeSureStartWithPlusOrEmpty = (value: string) => {
  return value.startsWith('+') || value === '' ? value : `+${value}`;
};

export default makeSureStartWithPlusOrEmpty;
